<template>
    <div class="blm-searching-contain">
        <div class="blm-searching-loading">
            <div class="searching-loader" v-if="isSearching"></div>
            <div class="searching-check-unequal" v-else></div>
        </div>
        {{ content }}
    </div>
</template>
<script>
export default {
    props: {
        content: {
            type: String,
            default: ""
        },
        isSearching: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
        };
    }
};
</script>
<style scoped lang="less">
@import (once) '@/styles/variable.less';
.blm-searching-contain {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
}
.blm-searching-loading {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}
.searching-loader {
    margin-top: 2px;
    border: 2px solid @primary-1;
    border-radius: 50%;
    border-top: 2px solid @white-color-6;
    width: 9px;
    height: 9px;
    animation: spinner 1.5s linear infinite;
}
@keyframes spinner {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
.searching-check-unequal {
    width: 5px;
    height: 10px;
    border-color: @primary-1;
    border-style: solid;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}
</style>